<template lang="html">

  <div class="trabaja-nosotros">

    <intro></intro>

    <section class="desc-work" v-if="showDescWork">
      <div class="flex wrap">
        <div class="col-50 flex column align-end pad-sec">
          <p>{{$t('trabaja_con_nosotros.intro.texto')}}</p>
        </div>
        <div class="col-50">

        </div>
      </div>
    </section>
    <section class="cv-form pad-sec">
      <div class="container">
        <formulario @showDescWork="showDescWork=$event"></formulario>
      </div>
    </section>
    

  </div>

</template>

<script lang="js">

  import Intro from '@/components/view-parts/intros/trabaja-con-nosotros'
  import formulario from '@/components/view-parts/trabaja-con-nosotros/formulario'

  export default  {
    name: 'trabaja-con-nosotros',
    props: [],
    mounted() {

    },
    data() {
      return {
        showDescWork: true
      }
    },
    methods: {

    },
    components: {
      'formulario' : formulario,
      'intro' : Intro
    }
  }
</script>

<style scoped>
.trabaja-con-nosotros {

}
</style>



// WEBPACK FOOTER //
// src/components/views/trabaja-con-nosotros.vue